import type { CreditReason } from "@nlc/shared-types";
import type { Key } from "react-aria-components";

import { FieldError, Label, TextArea, TextField } from "@/components/field";
import {
  Select,
  SelectButton,
  SelectListBox,
  SelectListItem,
  SelectPopover,
} from "@/components/select";

import { CREDIT_REASON_OPTIONS } from "../utils/credit-reason";

interface FieldProps<T> {
  readonly error?: string;
  readonly onBlur: () => void;
  readonly onChange: (value: T) => void;
  readonly value: T;
}

export function CreditReasonSelect({
  error,
  onBlur,
  onChange,
  value,
}: FieldProps<CreditReason | undefined>) {
  return (
    <Select
      isInvalid={!!error}
      onBlur={onBlur}
      onSelectionChange={(key: Key | null) => onChange(key as CreditReason)}
      placeholder="Select a reason"
      selectedKey={value ?? null}
      validationBehavior="aria"
    >
      <Label requiredHint>Reason</Label>
      <SelectButton />
      <FieldError>{error}</FieldError>
      <SelectPopover>
        <SelectListBox items={CREDIT_REASON_OPTIONS}>
          {(reason) => (
            <SelectListItem id={reason.id}>{reason.label}</SelectListItem>
          )}
        </SelectListBox>
      </SelectPopover>
    </Select>
  );
}

export function CreditNoteField({
  onBlur,
  onChange,
  placeholder,
  value,
}: {
  readonly placeholder: string;
} & Omit<FieldProps<string>, "error">) {
  return (
    <TextField onBlur={onBlur} onChange={onChange} value={value}>
      <Label>Note (optional)</Label>
      <TextArea className="resize-none" placeholder={placeholder} rows={3} />
    </TextField>
  );
}
